// extracted by mini-css-extract-plugin
export var background = "fl_y";
export var bottomBackground = "fl_lR";
export var card = "fl_cW";
export var container = "fl_f";
export var darkToLight = "fl_lS";
export var normal = "fl_hP";
export var small = "fl_b4";
export var topBackground = "fl_lQ";